import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { getLedgerDetails, printLedgerPdf} from '../../../../api/MyWalletAPI';
import AppBreadCrumb from '../../../common/AppBreadCrumb';

const MyWalletLedgerPage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [ledger, setLedger] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const fromDate = searchParams.get('from');
    const toDate = searchParams.get('to');

    useEffect(() => {
        if (!fromDate || !toDate) {
            navigate('/club_portal/wallet');
            return;
        }
        setIsLoading(true);
        getLedgerDetails({ from_date: fromDate, to_date: toDate }, (response) => {
            if (response) {
                setLedger(response);
            }
            setIsLoading(false);
        });
    }, [fromDate, toDate, navigate]);

    const handlePrint = () => {
        printLedgerPdf({ from_date: fromDate, to_date: toDate }, (response) => {
            // The risapi print function handles the download
            if(!response.success) {
                alert('Could not generate PDF.');
            }
        });
    };

    if (isLoading) return <div className="text-center p-5"><div className="spinner-border"></div></div>;
    if (!ledger) return <div className="text-center p-5">Could not load ledger data.</div>;

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title="Wallet Ledger" />
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h5>Ledger from {fromDate} to {toDate}</h5>
                        <button className="btn btn-primary btn-sm" onClick={handlePrint}>
                            <i className="fas fa-print me-2"></i>Print to PDF
                        </button>
                    </div>
                    <div className="card-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Description</th>
                                    <th className="text-end">Credit (₹)</th>
                                    <th className="text-end">Debit (₹)</th>
                                    <th className="text-end">Balance (₹)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="table-light">
                                    <td colSpan="4"><strong>Opening Balance</strong></td>
                                    <td className="text-end"><strong>{Number(ledger.opening_balance).toFixed(2)}</strong></td>
                                </tr>
                                {ledger.transactions.map((tx, index) => {
                                    // We need to calculate running balance on the frontend for display
                                    const runningBalance = (index === 0 ? ledger.opening_balance : parseFloat(ledger.transactions[index-1].running_balance)) + (tx.type === 'credit' ? parseFloat(tx.amount) : -parseFloat(tx.amount));
                                    tx.running_balance = runningBalance;
                                    return (
                                     <tr key={tx.id}>
                                        <td>{new Date(tx.transaction_date).toLocaleString()}</td>
                                        <td>{tx.description}</td>
                                        <td className="text-end text-success">{tx.type === 'credit' ? `+${Number(tx.amount).toFixed(2)}` : ''}</td>
                                        <td className="text-end text-danger">{tx.type === 'debit' ? `-${Number(tx.amount).toFixed(2)}` : ''}</td>
                                        <td className="text-end">{Number(runningBalance).toFixed(2)}</td>
                                    </tr>
                                )})}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default MyWalletLedgerPage;
